export default "__VITE_ASSET__BXx$qqs3__"